import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IOrderStatusEventEntity } from '../../model/api/order/order-status-event.entity.interface';
import { OrderEventStatusType } from '../../model/types/order-event-type';
import { IOrder } from '../../model/models/order/order-interface';
import { OrderStatusType } from '../../model/types/order-status-type';
import { APP_CONFIG } from '../../environment';

@Component({
  selector: 'rmt-track-timeline',
  templateUrl: 'rmt-track-timeline.html'
})
export class RmtTrackTimelineComponent {
  @Input() order: IOrder;
  orderEvents: IOrderStatusEventEntity[];
  activeEvent: OrderEventStatusType;
  
  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    if (this.order.events) {
      const isExpired = this.order.shownOrderStatus === OrderStatusType.Expired.toString()
          || this.order.status === OrderEventStatusType.ConfirmationExpired.toString();

      if (isExpired) {
        this.orderEvents = this.order.events.filter(w => w.event === OrderEventStatusType.Created);
        let extraText = this.translate.instant('page.trackReviewDetailsPage.pNMExpiredUnauthenticated');
        if (this.order.amountTo)
          extraText = this.translate.instant('page.trackReviewDetailsPage.pNMExpiredAuthenticated');
        this.orderEvents.push(
          { description: 'Expired',
            date: this.order.confirmationExpirationTimeUtc,
            event: OrderEventStatusType.Expired,
            extraText
          });
      } else {
        this.orderEvents = this.order.events.filter(event => this.shouldShowEvent(event));
      }

      this.orderEvents.forEach(e => {
        e.description = this.getEventText(e);
        if(e.date){
          this.activeEvent = e.event;
        }
      });
    }
  }

  shouldShowEvent(event): boolean {
    // always show events that have a date, even if they are cancelled
    if (event.date) {
      return true;
    }

    // for cancelled/refunded/toCancel orders, also show pending steps without a date
    const orderStatus = this.order.orderStatus || this.order.status;
    const pendingEvents = [OrderEventStatusType.Cancelled, OrderStatusType.ToCancel, OrderEventStatusType.Refunded];
    const cancelledStatuses = [OrderStatusType.Canceled, OrderStatusType.Refunded, OrderStatusType.ToCancel];

    if (cancelledStatuses.includes(orderStatus as OrderStatusType)) {
      return pendingEvents.indexOf(event.event) !== -1;
    }

    // hide cancelled events that does not fall in the above category
    return event.event !== OrderEventStatusType.Cancelled;
  }

  isCanceled(objEvent) {
    return objEvent.event === 'Cancelled';
  }

  isActiveEvent(event) {
    return event.event == this.activeEvent
  }

  isDisabledEvent(event) {
    return event.date == undefined;
  }

  isPaid(): boolean {
    if (this.order.events && this.order.events.length > 0)
    {
      const last = this.order.events[this.order.events.length - 1];
      if (last && last.event === 'Paid' && last.date)
        return true;
    }
    return this.order.orderStatus === 'Paid';
  }

  isDocumentsRequired(objEvent) {
    return objEvent.event === OrderStatusType.DocumentsRequired;
  }

  getEventText(timelineEvent: IOrderStatusEventEntity) {
    return timelineEvent.description;
  }

  isRefunded(objEvent) {
    return objEvent.event === OrderStatusType.Refunded;
  }

  getEventIcon(timelineEvent: IOrderStatusEventEntity, lastEvent: boolean): string {
    const iconPath = "assets/img/";
    let iconFileName = "check-circle.svg"; // Default icon

    if (this.isActiveEvent(timelineEvent)) 
      iconFileName = "check-circle.svg";

    if (this.isDisabledEvent(timelineEvent)) 
      iconFileName = "inactive-icon.svg";

    const isCompleted = this.isPaid() || (this.isRefunded(timelineEvent) && timelineEvent.date);
    if (lastEvent && isCompleted)
      iconFileName = "check-circle-green.svg";

    if(this.isDocumentsRequired(timelineEvent))
      iconFileName = "warning-circle.svg";

    return `${iconPath}${iconFileName}`;
  }

  getEventDate(dateFormat: string) {
    let eventDate = '';

    if(dateFormat) {
      const date = new Date(dateFormat);
      const monthsTranslated = this.translate.instant('global.myRia.jsonContent.MonthList');
      const months: string[] = monthsTranslated.split(',');
      const month = date.getMonth();
      const day = date.getDate();
      eventDate = APP_CONFIG.region.dateFormat.startsWith('DD') ? day + ' ' + months[month].trim() : months[month].trim() + ' ' + day;

      const hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      const minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const timePeriod = date.getHours() >= 12 ? "PM" : "AM";
      const time = `${hours}:${minutes} ${timePeriod}`;   
      const at = this.translate.instant('page.sendSummaryPage.detailsOfficePickup.anyLocationAt_WA').toLowerCase();

      eventDate = `${eventDate} ${at} ${time}`;
    }
    
    return eventDate;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-track-timeline/rmt-track-timeline.ts